import React, { Component } from 'react';
import axios from 'axios'
import { BrowserRouter, Route,  Navigate } from 'react-router-dom'
import Server from './../Server.js'
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { confirmAlert } from 'react-confirm-alert';
import { MultiSelect } from 'primereact/multiselect';
import { AutoComplete } from 'primereact/autocomplete';
import { Chip } from 'primereact/chip';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import { Toast } from "primereact/toast";
import DatePicker from 'react-datepicker2';
import moment from "moment-jalaali";

class Off_List extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();


    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetOffs = this.SetOffs.bind(this);

    this.state = {
      layout: 'list',
      name: "",
      ShopsList:[],
      type: "1",
      FId: "",
      DbTableName: "",
      usersList:[],
      DBTableField: "",
      latinName: "",
      ReserveItems: [{
        name: "همه",
        value: "all"
      }]

    }


  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.getReserveList();
    this.setState({
      loading: 1
    })
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0
      })
      that.getOffsList();

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }

  getReserveList() {
    let param = {
      token: localStorage.getItem("api_token"),
      active: true
    };
    let that = this;
    let SCallBack = function (response) {
      const ReserveItems = response.data.result.map((item)=> {return {value: item.number, name: item.name }})
      that.setState({
        ReserveItems: ReserveItems,
      })

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("AdminApi/GetReserve", param, SCallBack, ECallBack)
  }

  SetOffs() {
    let that = this;
    let usersList = this.state.usersList.filter(e => e.remove != "1");
    if(usersList.length == 0){
      usersList = null
    }
    let param = {
      token: localStorage.getItem("api_token"),
      _id: this.state.selectedId,
      fTitle: this.state.fTitle,
      lTitle: this.state.lTitle,
      all: this.state.all,
      Amount: this.state.Amount.toString().replace(/,/g, ""),
      percent: parseInt(this.state.percent),
      Date_hijri:this.state.Date.local("fa").format("jYYYY/jM/jD"),
      Date_Miladi:this.state.Date.format("YYYY/M/D"),
      Date: this.state.Date,
      enable: this.state.enable,
      usersList: usersList,
      useInForm: this.state.useInForm
    };
    this.setState({
      HasErrorForMaps: null,
      loading: 1
    })
    let SCallBack = function (response) {
      that.onHideFormsDialog();
      that.getOffsList();
      that.setState({
        loading: 0
      })
     that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
      that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
    }
    this.Server.send("AdminApi/setOffList", param, SCallBack, ECallBack)
  }
  CreateForm() {
    this.setState({
      visibleManageField: true,
      fTitle: "",
      all:false,
      enable:true,
      Amount:0,
      percent:0,
      lTitle: "",
      users: [{username:"",title:""}],
      selectedId: null,
      useInForm: null
    })

  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null
    });

  }

  selectedComponentChange(value) {
    var p = [];
    this.setState({
      fTitle: value.fTitle,
      lTitle: value.lTitle,
      all: value.all,
      enable: value.enable,
      Amount: value.Amount.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      percent: value.percent,
      Date: moment(value.Date),
      usersList: value.usersList || [],
      selectedId: value._id,
      visibleManageField: true,
      useInForm: value.useInForm



    })

  }
  getOffsList() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      GetAll: 1
    };
    this.setState({
      loading: 1
    })
    let SCallBack = function (response) {

      that.setState({
        GridDataFields: response.data.result
      })
      that.setState({
        loading: 0
      })
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
    }
    this.Server.send("AdminApi/getOffsList", param, SCallBack, ECallBack)
  }
  delField(rowData) {
    this.setState({
      visibleManageField:false
    })
    confirmAlert({
      title: <span className="yekan">حذف کاربر</span>,
      message: <span className="yekan">  آیا از حذف  {rowData.name} مطمئنید  </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: rowData._id,
              del:1
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0
              })
            //that.getScoreList();
             that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0
              })
              that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
            }
            this.Server.send("AdminApi/SetWallets", param, SCallBack, ECallBack)

          }
        },
        {
          label: <span className="yekan">خیر </span>
        }
      ]
    });

  }
  onSelect(event) {
    let List = this.state.usersList.filter(e => e.remove != "1");
    List.push({
        title: event.value.name,
        username: event.value.username
      })
      var flags = [], output = [], l = List.length, i;
    for (i = 0; i < l; i++) {
      if (flags[List[i].title]) continue;
      flags[List[i].title] = true;
      output.push(List[i]);
    }


    this.setState({
      searchName: event.value.name,
      searchId: event.value.username,
      usersList: output

    })
  }
  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });
    let param = {};
       param = {
        title: event.query,
        table:"users",
        name:["name","username","RaymandAcc","RaymandUser"]
      };
    
    
    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({ _id: v._id,name:v.name,username:v.username})
      })
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {

    }
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack)


}
itemTemplate(brand) {
    return (
      <div className="p-clearfix" style={{ direction: 'rtl',maxWidth:'100%' }} >
        <div style={{ margin: '10px 10px 0 0' }} className="row" username={brand.username} >
          <div className="col-8" username={brand.username} style={{ textAlign: 'right' }}>
            <span className="iranyekanwebregular" style={{ textAlign: 'right', overflow: 'hidden' }} username={brand.username} >
              <span style={{whiteSpace:'pre-wrap'}} username={brand.username}>{brand.name}</span><br />
            </span>
          </div>
          
        </div>
      </div>
    );
  }
  render() {
    const footer = (
      <div>
        <button className="btn btn-primary irsans" onClick={this.SetOffs} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}> اعمال </button>

      </div>
    );

    const delTemplate = (rowData, props) => {
      return <i className="fa fa-times" style={{ cursor: 'pointer' }} aria-hidden="true" onClick={() => this.delField(rowData)}></i>;
    }
    return (

      <div style={{ direction: 'rtl' }}>
        {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }
        <div className="row justify-content-center">

          <div className="col-12" style={{ background: '#fff' }}>
            <div className="row" >
              <div className="col-12" style={{ textAlign: 'right' }}>
                <button className="btn btn-primary irsans" onClick={this.CreateForm} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}>ساخت ردیف جدید</button>
              </div>

            </div>
            <div className="section-title " style={{ textAlign: 'right' }}><span className="title IRANYekan" style={{ fontSize: 17, color: 'gray' }} >لیست کدها</span></div>

            <DataTable responsive value={this.state.GridDataFields} selectionMode="single" selection={this.state.selectedComponent} onSelectionChange={e => this.selectedComponentChange(e.value)}>
              <Column field="fTitle" header="شماره" className="irsans" style={{ textAlign: "right" }} />
              <Column field="lTitle" header="نام" className="irsans" style={{ textAlign: "right" }} />
              <Column field="del" body={delTemplate} header="حذف" className="irsans" style={{ textAlign: "right" }} />
            </DataTable>
          </div>

        </div>


        <Dialog header={this.state.selectedId ? `اصلاح ${this.state.fTitle}` : "ساخت ردیف جدید"} visible={this.state.visibleManageField}  footer={footer} minY={70} onHide={this.onHideFormsDialog} maximizable={true} maximized={true}>
          <form>

            <div className="row" style={{alignItems:'baseline'}}>
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.fTitle} name="fTitle" onChange={(event) => this.setState({ fTitle: event.target.value })} required="true" />
                  <label>موضوع</label>
                </div>  
              </div>
              <div className="col-lg-6 col-12">

                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.lTitle} name="lTitle" onChange={(event) => this.setState({ lTitle: event.target.value })} required="true" />
                  <label >کد لاتین</label>

                </div>
              </div>

              
              <div className="col-lg-6 col-12">

                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.percent} name="percent" onChange={(event) => this.setState({ percent: event.target.value })} required="true" />
                  <label >درصد</label>

                </div>
              </div>
              <div className="col-lg-6 col-12">

                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.Amount} name="Amount" onChange={(event) => this.setState({ Amount: event.target.value.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") })} required="true" />
                  <label >{this.state.percent ? "حداکثر" : ""} مبلغ (ریال)</label>

                </div>
              </div>
              <div className='col-lg-6 col-12'>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <label className="labelNoGroup irsans">قابل استفاده در :</label>
                        <MultiSelect
                              value={this.state.useInForm}
                              optionLabel="name"
                              optionValue="value"
                              options={this.state.ReserveItems}
                              onChange={(event) => {
                                this.setState({useInForm: event.value });
                              }}

                         />
                       
                      </div>
              </div>
              <div className="col-lg-6 col-12">
                  <div style={{marginRight:8}}>آخرین مهلت استفاده</div>
                  <DatePicker
                    onChange={value => this.setState({ Date: value })}
                    value={this.state.Date}
                    isGregorian={false}
                    timePicker={false}
                    placeholder="تاریخ "
                    persianDigits={false}

                  />

                </div>
              
              <div className="col-lg-12">

              <div className="group" >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox inputId="active" value={this.state.all} checked={this.state.all} onChange={e => this.setState({ all: e.checked , usersList: e.checked ? [] : this.state.usersList })}></Checkbox>
                        <label htmlFor="active" className="p-checkbox-label yekan" style={{ paddingRight: 5,marginBottom:0 }}>همه ی کاربران</label>
                      </div>
              </div>
              </div>
                
                    <div className="col-lg-12">
                    <div className="group">

                    <AutoComplete disabled={this.state.all} placeholder="بخشی از نام / شماره موبایل / شناسه کاربری / شماره حساب  را وارد کنید"  style={{ width: '100%' }} onChange={(event)=>{this.setState({searchName:event.value})}} itemTemplate={this.itemTemplate.bind(this)} value={this.state.searchName} onSelect={(e) => this.onSelect(e)} suggestions={this.state.brandSuggestions} completeMethod={this.suggestBrands.bind(this)} />
                        <div style={{ marginTop: 10, textAlign: 'right', marginBottom: 10 }}>
                        {typeof this.state.usersList == "object" && this.state.usersList.map((v, i) => {
                            if ((v.title || v.username) && !v.remove) {
                            return (<Chip label={v.title||v.username} _id={v._id} style={{ marginLeft: 5 }} removable={true} onRemove={(event) => {
                                let title = event.target.parentElement.getElementsByClassName("p-chip-text")[0].textContent;
                                let List = this.state.usersList;
                                for (let i = 0; i < List.length; i++) {
                                if (List[i].title == title || List[i].username == title) {
                                    List[i].remove = 1;
                                }
                                }

                            }} />)
                            }

                        })
                        }
                        </div>
                    
                    
                    
                    </div>
                </div>
                
              
              <div className="col-lg-12">

              <div className="group" >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox inputId="active" value={this.state.enable} checked={this.state.enable} onChange={e => this.setState({ enable: e.checked })}></Checkbox>
                        <label htmlFor="active" className="p-checkbox-label yekan" style={{ paddingRight: 5,marginBottom:0 }}>فعال</label>
                      </div>
              </div>
              </div>
             
              


            </div>
          </form>
        </Dialog>

      </div>





    )
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default connect(mapStateToProps)(Off_List);
